/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w) {
	"use strict";
	/*globals Tc, window */

	/**
	 * UserFeedback for tracking user actions
	 *
	 * @author Rami Attallah, Elena Wessolek, Cesar Keller
	 * @namespace Tc.Module
	 * @class UserFeedback
	 * @extends Tc.Module
	 */
	Tc.Module.UserFeedback = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find("[baynote_fbhelpful]").click(function() {
				var $button = $(this),
					feedbackVal = $button.attr('baynote_fbhelpful');

				// LivePerson JavaScript was already loaded by the LivePerson Chat component
				if (feedbackVal && w.lpSendData) {
					// send to LivePerson
					w.lpMTagConfig = w.lpMTagConfig || {};
					w.lpMTagConfig.vars = w.lpMTagConfig.vars || [];
					w.lpMTagConfig.vars.push(['page', 'PageContentUserFeedbackHelpful', feedbackVal]);
					w.lpSendData();
					w.debug.log("Tc.Module.UserFeedback", feedbackVal, w.lpMTagConfig);
				} else {
					w.debug.warn("Tc.Module.UserFeedback cannot send", feedbackVal, w.lpSendData);
				}

			});

			callback();
		}
	});
}(Tc.$, window));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.UserFeedback.js
// module id = 196
// module chunks = 0